<template>
  <div>
    <div
      v-if="widget"
      class="d-flex flex-column align-items-center justify-content-center text-center quickadd-tile"
      :class="busy ? 'quickadd-busy' : ''"
      @click="add"
    >
      <b-avatar
        :variant="`light-${widget.param.color || 'primary'}`"
        size="45"
        class="mb-50"
      >
        <feather-icon
          size="21"
          :icon="widget.param.icon || 'PlusIcon'"
        />
      </b-avatar>
      <h4 class="mb-25 font-weight-bolder">
        {{ widget.param.title || '+1' }}
      </h4>
      <span
        v-if="count !== null"
        class="small text-muted"
      >
        {{ todayLabel }}: {{ count }}
      </span>
    </div>
    <cbs-debug
      v-if="false"
      :context="this"
    />
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import useJwt from '@/cubus/jwt/useJwt'
import useCubus from '@/cubus/services/useCubus'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'

export default {
  name: 'CbsWidgetQuickadd',
  components: {
    CbsDebug,
    BAvatar,
  },
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      count: null,
      busy: false,
    }
  },
  computed: {
    todayLabel() {
      return this.widget.param.counter_label || 'сегодня'
    },
  },
  created() {
    this.refreshCount()
  },
  methods: {
    // load-only call: returns the current counter without inserting
    refreshCount() {
      this.callQuickadd(false)
    },
    add() {
      if (this.busy) return
      this.busy = true
      this.callQuickadd(true)
    },
    callQuickadd(doAdd) {
      // mode:sync — the action returns { result: {...} } directly (no thread polling)
      useJwt.query({
        query: {
          method: 'widget_quickadd',
          mode: 'sync',
          param: { widgetid: this.widget.id, add: doAdd },
        },
      })
        .then(response => {
          this.busy = false
          if (response.data.error) {
            useCubus.toastError(this, response.data.error)
            return
          }
          const res = response.data.result
          if (!res) return
          if (res.count !== undefined && res.count !== null) {
            this.count = res.count
          }
          if (doAdd && res.success) {
            useCubus.toastMessage(this, `${this.widget.param.title || 'Запись'} — добавлено`)
          }
        })
        .catch(error => {
          this.busy = false
          useCubus.toastError(this, error.toString())
        })
    },
  },
}
</script>

<style scoped>
.quickadd-tile {
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: background-color 0.15s ease;
  user-select: none;
}
.quickadd-tile:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.quickadd-busy {
  opacity: 0.5;
  pointer-events: none;
}
</style>
